<template>
    <span
        class="card-challenge-result-declaration-completed"
        :class="resultClass">{{ declarationText }}</span>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            resultItem: {
                type: Object,
                default: {
                    id: 9,
                    status: "COMPLETED",
                    user1: {
                        id: 1,
                        username: "temren",
                        status: "DONE-PRACTICE"
                    },
                    user2: {
                        id: 3,
                        username: "kral1790",
                        status: "DONE-PRACTICE"
                    },
                    results: {
                        draw: false,
                        user1: "winner",
                        user2: "loser",
                    },
                    stats: {
                        correctness: {
                            user1: 40,
                            user2: 10
                        },
                        correct: {
                            user1: 15,
                            user2: 12
                        },
                        incorrect: {
                            user1: 3,
                            user2: 7
                        },
                        skipped: {
                            user1: 2,
                            user2: 1
                        }
                    }
                }
            },
        },

        computed: {
            declarationText(){
                let curUserType = 'user' + this.$store.state.challengeSession.userType;
                if(this.resultItem.results.draw){
                    return this.$t('challenge.results.draw');
                }
                return this.$t(`challenge.results.${this.resultItem.results[curUserType]}`) + 'N';
            },
            resultClass(){
                let curUserType = 'user' + this.$store.state.challengeSession.userType;
                if(this.resultItem.results.draw){
                    return 'card-challenge-result-declaration-completed--draw';
                }
                return 'card-challenge-result-declaration-completed--' + this.resultItem.results[curUserType];
            }
        }
    };
</script>

<style scoped src="@/css/components/card-challenge-result-declaration-completed.css"></style>